/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Action, INIT } from '@ngrx/store';
import { ConstraintViolation, User } from '@shared/models';

export const LOAD_USERS = '[Users] Load';
export const LOAD_USERS_SUCCESS = '[Users] Load success';
export const LOAD_USERS_FAILURE = '[Users] Load failure';
export const EDIT_USER = '[User] Edit';
export const DEACTIVATE_USER = '[User] Deactivate';
export const EDIT_USER_PROFILE = '[User] Edit User Profile';
export const LOAD_USER = '[User] Load';
export const LOAD_USER_SUCCESS = '[User] Load success';
export const LOAD_USER_FAILURE = '[User] Load failure';
export const PERSIST_USER = '[User] Persist';
export const PERSIST_USER_SUCCESS = '[User] Persist success';
export const PERSIST_USER_FAILURE = '[User] Persist failure';
export const UPDATE_ACCOUNT = '[User] Update Account';
export const UPDATE_ACCOUNT_SUCCESS = '[User] Update Account Success';
export const UPDATE_ACCOUNT_FAILURE = '[User] Update Account Failure';

export class Init implements Action {
  readonly type = INIT;
}

export class LoadUsers implements Action {
  readonly type = LOAD_USERS;
}

export class LoadUsersSuccess implements Action {
  readonly type = LOAD_USERS_SUCCESS;
  constructor(public users: User[]) { }
}

export class LoadUsersFailure implements Action {
  readonly type = LOAD_USERS_FAILURE;
}

export class EditUser implements Action {
  readonly type = EDIT_USER;
  constructor(public userId?: string) { }
}

export class DeactivateUser implements Action {
  readonly type = DEACTIVATE_USER;
  constructor(public user?: User) { }
}

export class EditUserProfile implements Action {
  readonly type = EDIT_USER_PROFILE;
  constructor(public userId: string) {}
}

export class LoadUser implements Action {
  readonly type = LOAD_USER;
  constructor(public userId?: string) { }
}

export class LoadUserSuccess implements Action {
  readonly type = LOAD_USER_SUCCESS;
  constructor(public user: User) { }
}

export class LoadUserFailure implements Action {
  readonly type = LOAD_USER_FAILURE;
}

export class PersistUser implements Action {
  readonly type = PERSIST_USER;
  constructor(public user: User) { }
}

export class PersistUserSuccess implements Action {
  readonly type = PERSIST_USER_SUCCESS;
}

export class PersistUserFailure implements Action {
  readonly type = PERSIST_USER_FAILURE;
  constructor(public violations: ConstraintViolation[] = []) { }
}

export class UpdateAccount implements Action {
  readonly type = UPDATE_ACCOUNT;
  constructor(public payload: User) { }
}

export class UpdateAccountSuccess implements Action {
  readonly type = UPDATE_ACCOUNT_SUCCESS;
}

export class UpdateAccountFailure implements Action {
  readonly type = UPDATE_ACCOUNT_FAILURE;
  constructor(public payload: string) { }
}

export type UsersActions = LoadUsers | LoadUsersSuccess | LoadUsersFailure | LoadUser | LoadUserSuccess | LoadUserFailure |
  PersistUser | PersistUserSuccess | PersistUserFailure | EditUser | EditUserProfile | UpdateAccount | UpdateAccountSuccess |
  UpdateAccountFailure;
